import script from "./InflowReport.vue?vue&type=script&setup=true&lang=js"
export * from "./InflowReport.vue?vue&type=script&setup=true&lang=js"

import "./InflowReport.vue?vue&type=style&index=0&id=c16e9d8a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c16e9d8a"]])

export default __exports__